const getEnvVar = (name: string, fallback: string): string => {
  if (typeof process !== 'undefined' && process.env) {
    return process.env[name] || fallback;
  }
  return fallback;
};

// When EXPO_PUBLIC_AWS_API_ENDPOINT is not set at build time (e.g. Amplify build),
// use production API when the app is served from app.binyumatv.com so login and API calls work.
function getApiEndpoint(): string {
  const fromEnv = getEnvVar('EXPO_PUBLIC_AWS_API_ENDPOINT', '');
  if (fromEnv) return fromEnv;
  if (typeof window !== 'undefined' && window.location?.hostname === 'app.binyumatv.com') {
    return 'https://api.binyumatv.com';
  }
  return '';
}

const AWS_CONFIG = {
  region: getEnvVar('EXPO_PUBLIC_AWS_REGION', 'eu-west-1'),
  get apiEndpoint(): string {
    return getApiEndpoint();
  },
  cognito: {
    userPoolId: getEnvVar('EXPO_PUBLIC_AWS_COGNITO_USER_POOL_ID', ''),
    clientId: getEnvVar('EXPO_PUBLIC_AWS_COGNITO_CLIENT_ID', ''),
  },
  cloudfront: {
    distributionUrl: getEnvVar('EXPO_PUBLIC_CLOUDFRONT_URL', ''),
  },
  s3: {
    bucket: getEnvVar('EXPO_PUBLIC_S3_BUCKET', ''),
    region: getEnvVar('EXPO_PUBLIC_AWS_REGION', 'eu-west-1'),
  },
} as const;

let hasWarnedMissingCloudfront = false;

export function isAWSConfigured(): boolean {
  return !!(
    AWS_CONFIG.apiEndpoint &&
    AWS_CONFIG.cognito.userPoolId &&
    AWS_CONFIG.cognito.clientId
  );
}

export function getCloudFrontUrl(path: string): string {
  if (AWS_CONFIG.cloudfront.distributionUrl) {
    return `${AWS_CONFIG.cloudfront.distributionUrl}/${path}`;
  }
  if (!hasWarnedMissingCloudfront && path) {
    hasWarnedMissingCloudfront = true;
    // In development this helps catch misconfigured environments where media
    // URLs would fall back to direct S3 access (which is often private).
    console.warn(
      '[AWS config] EXPO_PUBLIC_CLOUDFRONT_URL is not set. Falling back to raw paths/S3 URLs; media playback may fail if the S3 bucket is private.',
    );
  }
  return path;
}

export function getS3Url(key: string): string {
  if (AWS_CONFIG.s3.bucket) {
    return `https://${AWS_CONFIG.s3.bucket}.s3.${AWS_CONFIG.s3.region}.amazonaws.com/${key}`;
  }
  return key;
}

export default AWS_CONFIG;
